<template>
    <div id="selBranchBox">
        <div class="searchWrap">
            <div class="row">
                <div class="itemBox">
                    <label>上傳檔案：</label>
                    <div style="display: flex; flex-direction: row; align-items: center;">
                        <input
                          type="file"
                          @change="handleFileChange"
                                                    accept=".xlsx"
                          ref="fileInput"
                          style="display:none"
                        />
                        <el-button size="small" type="primary" icon="el-icon-upload" @click="triggerFileInput">選擇檔案</el-button>
                        <span v-if="selectedFile" style="margin-left: 10px;">
                          已選擇: {{ selectedFile.name }}
                        </span>
                        <a href="/tbbint.xlsx" download="tbbint.xlsx" style="margin-left: 10px;">下載範例檔案</a>
                    </div>
                </div>                                    
            </div>
            <div class="row" style="margin: -10px 0px 15px 90px;font-size: smaller;color:green"> 
                    格式: 項次, 客戶ID/統編, 姓名, 匯入匯出額度, 實績行名稱(代號)          
            </div>
              
            <!-- 預覽上傳的資料 -->
            <div class="row" v-if="parsedData.length > 0">
                <div class="itemBox preview-container">
                    <h4>檔案預覽 (前 5 筆資料):</h4>
                    <el-table :data="parsedData.slice(0, 5)" border style="width: 100%">
                        <el-table-column prop="項次" label="項次" width="60"></el-table-column>
                        <el-table-column prop="客戶ID/統編" label="客戶ID/統編" ></el-table-column>
                        <el-table-column prop="姓名" label="姓名"></el-table-column>
                        <el-table-column prop="一年內有匯出匯入貸款性質別卻沒有進出口額度之法人客戶" label="匯入匯出額度"></el-table-column>
                        <el-table-column prop="實績行名稱(代號)" label="實績行名稱(代號)" ></el-table-column>
                        <el-table-column prop="error" label="錯誤" width="150"></el-table-column>
                    </el-table>
                    <div style="margin-top: 10px; color: #606266; font-size: 14px;">
                        共 {{ parsedData.length }} 筆資料
                    </div>
                </div>
            </div>

            <!-- 加入潛在客戶的原因 -->
            <!-- <div class="row">
                <div class="itemBox">
                    <label>備註：</label>
                    <el-input type="textarea" rows="2" v-model="addInfo.memo" placeholder="簡明描述備註" style="width:40%" clearable></el-input>
                </div>
            </div>                -->
            <div class="row" style="margin:auto;">
                <el-button type="primary" @click="submitData" :disabled="parsedData.length === 0 || hasErrors" :loading="submitting" icon="el-icon-check">提交資料</el-button>
                <el-button type="danger" @click="resetUploadForm" icon="el-icon-close">重置</el-button>
            </div>
        </div>

        <el-dialog title="資料檢核錯誤" :visible.sync="errorDialogVisible" width="50%" center>
            <div style="max-height: 400px; overflow-y: auto;">
                <div style="margin-bottom: 10px; color: #E6A23C; font-weight: bold;">
                    共發現 {{ validationErrors.length }} 個錯誤：
                </div>
                <el-table :data="validationErrors" border stripe style="width: 100%;">
                    <el-table-column prop="row" label="列數" width="120"></el-table-column>
                    <el-table-column prop="error" label="錯誤訊息"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="errorDialogVisible = false">確定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ExcelJS from 'exceljs';
import { notify, handleError } from '@/utils/notify';

export default {
    data() {
        return {     
            analysisTitle: '分析資料',       
            addInfo: {                
                RepName: '',
                memo: ''
            },
            selectedFile: null,
            parsedData: [],
            submitting: false,
            uploadFileName: '',
            errorDialogVisible: false,
            validationErrors: [],
        };
    },
    computed: {
        hasErrors: function() {
            return this.parsedData.some(item => item.error);
        }
    },
    methods: {
        // 觸發檔案選擇
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        
        // 處理選擇的檔案
        handleFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            // 檢查檔案類型
            const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                /\.xlsx$/i.test(file.name || '');
            
            if (!isExcel) {
                this.$message.error('只能上傳 .xlsx 檔案!');
                return;
            }
            
            if (file.size > 10 * 1024 * 1024) {
                this.$message.error('檔案大小不能超過 10MB!');
                return;
            }
            this.uploadFileName = file.name;
            this.selectedFile = file;
            this.readExcelFile(file);
        },
        
        // 讀取 Excel 檔案內容
        readExcelFile(file) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const cellValueToPlain = (value) => {
                        if (value === null || value === undefined) return '';
                        if (typeof value !== 'object') return value;
                        if (Array.isArray(value.richText)) {
                            return value.richText.map(part => part && part.text ? part.text : '').join('');
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'text')) {
                            return value.text || '';
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'result')) {
                            return cellValueToPlain(value.result);
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'hyperlink')) {
                            return value.text || value.hyperlink || '';
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'formula')) {
                            return cellValueToPlain(value.result);
                        }
                        try {
                            return JSON.stringify(value);
                        } catch (err) {
                            return String(value);
                        }
                    };

                    const normalizeHeader = (value) => String(value || '')
                        .replace(/\uFEFF/g, '')
                        .replace(/[\s\u3000]/g, '')
                        .toLowerCase();

                    const data = e.target.result;
                    const workbook = new ExcelJS.Workbook();
                    await workbook.xlsx.load(data);

                    const firstSheet = workbook.worksheets[0];
                    if (!firstSheet) {
                        this.$message.error('Excel 檔案沒有工作表');
                        return;
                    }

                    const rows = [];
                    firstSheet.eachRow({ includeEmpty: false }, row => {
                        rows.push(row.values.slice(1));
                    });

                    if (rows.length < 2) {
                        this.$message.error('Excel 檔案內容為空，請確認資料格式');
                        return;
                    }

                    const headers = rows[0].map(h => String(cellValueToPlain(h) || '').trim());

                    const candidateKeys = [
                        '客戶id/統編',
                        '客戶id統編',
                        '客戶統編',
                        '統編'
                    ];
                    const customerIdHeader = headers.find(h => candidateKeys.includes(normalizeHeader(h)));

                    const jsonData = rows.slice(1).map(row => {
                        const item = {};
                        headers.forEach((header, idx) => {
                            if (!header) return;
                            item[header] = cellValueToPlain(row[idx]);
                        });
                        if (customerIdHeader && customerIdHeader !== '客戶ID/統編') {
                            item['客戶ID/統編'] = item[customerIdHeader];
                        }
                        return item;
                    });
                    
                    // 檢查數據格式是否符合要求
                    if (jsonData.length === 0) {
                        this.$message.error('Excel 檔案內容為空，請確認資料格式');
                        return;
                    }

                    const normalizedData = jsonData.map((item, index) => {
                        const rowData = { ...item };
                        rowData._excelRow = index + 2;
                        return rowData;
                    });

                    const filteredData = normalizedData.filter((item) => {
                        const customerIdRaw = item['客戶ID/統編'];
                        const idStr = customerIdRaw === null || customerIdRaw === undefined ? '' : String(customerIdRaw).trim();
                        return idStr !== '';
                    });

                    this.validateCustomerId(filteredData);
                    this.parsedData = filteredData;
                    console.log('解析後的資料:', this.parsedData);
                    this.$message({
                        message: `已成功讀取 ${this.parsedData.length} 筆資料`,
                        type: 'success'
                    });
                } catch (error) {
                    console.error('解析 Excel 檔案時發生錯誤:', error);
                    this.$message.error('解析檔案失敗，請確認檔案格式是否正確');
                }
            };
            
            reader.onerror = () => {
                this.$message.error('讀取檔案時發生錯誤');
            };
            
            reader.readAsArrayBuffer(file);
        },

        validateCustomerId(data) {
            const validationErrors = [];

            data.forEach((item) => {
                const rowErrors = [];
                const customerIdRaw = item['客戶ID/統編'];
                const idStr = customerIdRaw === null || customerIdRaw === undefined ? '' : String(customerIdRaw).trim();

                if (!idStr) {
                    rowErrors.push('客戶ID/統編為必填欄位');
                } else {
                    if (idStr.length !== 8 && idStr.length !== 9) {
                        rowErrors.push(`客戶ID/統編長度需為 8 或 9 碼，目前為 ${idStr.length} 碼`);
                    } else {
                        const isValid8Digit = /^\d{8}$/.test(idStr);
                        const isValid9WithLetter = /^\d{8}[A-Za-z]$/.test(idStr);
                        if (!isValid8Digit && !isValid9WithLetter) {
                            rowErrors.push('客戶ID/統編格式錯誤：8碼請填數字；9碼請以前8碼數字 + 第9碼英文字母');
                        }
                    }
                }

                if (rowErrors.length > 0) {
                    item.error = rowErrors.join('；');
                    rowErrors.forEach((err) => {
                        validationErrors.push({
                            row: `第 ${item._excelRow} 列`,
                            error: err,
                        });
                    });
                } else {
                    item.error = '';
                }
            });

            this.validationErrors = validationErrors;
            this.errorDialogVisible = validationErrors.length > 0;
        },
        
        // 提交數據到後端 API
        async submitData() {
            if (this.parsedData.length === 0) {
                this.$message.warning('沒有可提交的數據');
                return;
            }

            if (this.hasErrors) {
                this.errorDialogVisible = true;
                this.$message.warning('請先修正檔案資料錯誤後再提交');
                return;
            }
            
            this.submitting = true;

            let parsedCount = 0;

            
            try {
                // 構建要發送的數據
                const UniComNmList = this.parsedData.map(item => item['客戶ID/統編'].toString().trim());
                const qry = {
                    uni_com_nm_list: UniComNmList
                };
                console.log('提交的查詢參數:', qry);
                const response = await this.$api.apidata.get_servicing_branch(qry);
                console.log('API 回應:', response);
                if( response.total && response.success > 0 ){
                    const message = `共計 ${response.total} 筆資料中，有 ${response.success} 筆找到歸屬分行，有 ${response.failed} 筆未找到歸屬分行。`;
                    notify({
                        title: '成功',
                        message: message,
                        type: 'success',
                    });
                }

                const branchDataMap = response.data.reduce((map, item) => {
                    map[item.UniComNm] = item.Branch;
                    return map;
                }, {});

                // 移除this.parsedData中的欄位"error"
                this.parsedData.forEach(item => {
                    delete item.error;
                    delete item._excelRow;
                });

                this.parsedData.forEach(item => {
                    const uniComNm = item['客戶ID/統編'].toString().trim();
                    if (branchDataMap[uniComNm]) {
                        item["實績行名稱(代號)"] = branchDataMap[uniComNm];
                    } else {
                        item["實績行名稱(代號)"] = '未找到';
                    }
                });

                // 將this.parsedData轉成Excel檔案並讓使用者下載
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('歸屬分行');

                const headers = Object.keys(this.parsedData[0] || {});
                worksheet.addRow(headers);
                this.parsedData.forEach(item => {
                    worksheet.addRow(headers.map(header => item[header]));
                });
                               
                // 檔名加上日期時間戳記
                const timestamp = new Date().toISOString().replace(/[-:.]/g, '');
                const filename = `歸屬分行_${timestamp}.xlsx`;
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                
                // 重置表單
                this.resetUploadForm();
                
            } catch (error) {
                console.error('提交數據時發生錯誤:', error);
                this.$message.error(`提交失敗: ${error.message || '未知錯誤'}`);
            } finally {

                // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
                const setAudit = {
                    "menu_path": ["客戶名單管理", "歸屬分行分析"],
                    "action_type": "submit",
                    "action_name": "提交資料",
                    "details": {
                        "file_name": this.uploadFileName,
                        "parsed_count": this.parsedData.length,
                    }
                }
                const resp = await this.$api.apimgrs.setAuditLog(setAudit);                
                this.submitting = false;
            }
        },
        
        // 重置表單
        resetUploadForm() {
            this.selectedFile = null;
            this.parsedData = [];
            this.validationErrors = [];
            this.errorDialogVisible = false;
            this.addInfo.memo = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },

        // 保留舊方法供參考
        analyzeData() {
            if (this.parsedData.length === 0) {
                this.$message.warning('請先上傳並解析檔案');
                return;
            }
            
            this.analysisTitle = '分析中...'
            setTimeout(() => {
                this.analysisTitle = '分析資料'
                this.$message({
                    message: '資料分析完成，請確認結果',
                    type: 'success'
                });
                this.analysisTitle = '請點此下載'
            }, 2000);
        }
    }
}
</script>


<style lang="scss" scoped>
#selBranchBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;

    .searchWrap   {
        display: flex;
        flex-direction: column;    
        justify-content: flex-start;
        padding: 0px 5%;
        .row {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            

            .itemWrap {
                outline: red 1px solid;
                span {
                    margin-right: 10px;
                }
                display: flex;
                flex-direction: row;
                align-items: center;                
                margin-top:10px; 
                margin-bottom: 10px;
            }
            
            .itemBox {
                display: flex;
                flex-direction: row;    
                justify-content: flex-start;
                align-items: center;
                margin: 10px 0;
                width: 100%;
                
                &.preview-container {
                    flex-direction: column;
                    align-items: flex-start;
                    margin-top: 20px;
                    
                    h4 {
                        margin-bottom: 15px;
                        color: #409EFF;
                    }
                    
                    .el-table {
                        margin-bottom: 10px;
                    }
                }
                
                label {            
                    margin-right: 10px;
                    white-space: nowrap;
                    font-weight: bold;
                    min-width: 80px; /* 確保標籤有足夠的寬度 */
                }
                
                .el-upload {
                    display: inline-flex;
                    align-items: center;
                }
            }
        }        
  }
    .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   } 
}

  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: center;
            }
        }
    }
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }    
  }


</style>